
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">如何使用粉丝海报？</div>
      <div class="panel-body">
        <span
          class="span1"
        >粉丝海报功能是使用率非常高的一个推广功能，为了满足用户的更多需求，我们推出了粉丝海报。粉丝海报易推广原因分析：每个粉丝的朋友圈人数少则几百多则几千，即使不是企业的粉丝，也能看到企业的活动或是产品的介绍，可谓是对公司品牌的裂变式宣传。企业更是能在后台看到每个粉丝的推广效果，从而实现奖励，激发粉丝推广的积极性。</span>
        <p class="p1">一、制作海报模板:</p>
        <p class="span1">1、海报上可以说明活动的信息，以及粉丝推广的奖励机制</p>
        <p class="p1">二、为海报添加二维码，配置回复语:</p>
        <p class="span1">
          1、登录汇客软件营销平台-二维码管理-二维码模板-新建二维码模板-填写信息回复语分为3条，
          <br />扫码回复：粉丝扫码关注公众号时给粉丝的回复(给关注者)
          <br />生成回复:分享者在公众号内点击菜单生成二维码模板时的回复(给分享者)
          <br />关注通知：粉丝扫描分享者生成的二维码关注公众号时给该分享者的通知(给分享者)
          <br />2、设置菜单项，设置好模板后，就可以把该模板添加到公众号的菜单中了。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


